module.exports = __webpack_public_path__ + "img/utility-impostor.5152472e.webp";